import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faUnlock } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

import styles from './styles.module.scss';
import errorMsg from '../../Functions/errorMsg';

const MapWithLocation = ({ address, city, zipCode }) => {
  const mapContainer = useRef(null);
  const [map, setMap] = useState(null);
  const [center, setCenter] = useState(null);
  const [mapInteractive, setMapInteractive] = useState(false);

  useEffect(() => {
    const fetchCoordinates = async () => {
      try {
        const response = await axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${address}, ${city}, ${zipCode}.json?access_token=pk.eyJ1Ijoid2Fjb2V4Y2hhbmdlIiwiYSI6ImNsdDI3bnFvbTByODQybXF4bnV6eHZvNW0ifQ.b1kQixq2mV4ChcEys0i4XQ`);
        const { features } = response.data;
        if (features && features.length > 0) {
          const { center } = features[0];
          setCenter(center);
        }
      } catch (error) {
        errorMsg("Could not locate this location.");
      }
    };

    fetchCoordinates();
  }, [address, city, zipCode]);

  useEffect(() => {
    if (!center) return;

    mapboxgl.accessToken = 'pk.eyJ1Ijoid2Fjb2V4Y2hhbmdlIiwiYSI6ImNsdDI3bnFvbTByODQybXF4bnV6eHZvNW0ifQ.b1kQixq2mV4ChcEys0i4XQ';

    const initializedMap = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/wacoexchange/clt29tbhd01w901p471g3hcj3',
      center,
      zoom: 15,
    });
  
    // Custom marker element with SVG
    const markerElement = document.createElement('div');
    markerElement.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#154734bd" stroke="#ffffff67" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"></path>
        <circle cx="12" cy="9" r="2"></circle>
      </svg>
    `;
    markerElement.style.width = '50px';
    markerElement.style.height = '50px';

    new mapboxgl.Marker({ element: markerElement }).setLngLat(center).addTo(initializedMap);

    setMap(initializedMap);

    return () => {
      initializedMap.remove();
    };
  }, [center]);

  useEffect(() => {
    if (map) {
      if (mapInteractive) {
        map.boxZoom.enable();
        map.scrollZoom.enable();
        map.dragPan.enable();
        map.dragRotate.enable();
        map.keyboard.enable();
        map.doubleClickZoom.enable();
      } else {
        map.boxZoom.disable();
        map.scrollZoom.disable();
        map.dragPan.disable();
        map.dragRotate.disable();
        map.keyboard.disable();
        map.doubleClickZoom.disable();
      }
    }
  }, [map, mapInteractive]);

  const toggleMapInteraction = () => {
    setMapInteractive(!mapInteractive);
  };

  return (
    <div id={styles.wrapper}>
      <div id={styles.container}>
        <div ref={mapContainer} style={{ width: '100%' }} />
        <div style={{ position: 'absolute', top: '10px', left: '10px', zIndex: 99 }}>
          <button id={styles.toggleInteraction} onClick={toggleMapInteraction}>
            {mapInteractive ? <FontAwesomeIcon icon={faUnlock} id={styles.icon} /> : <FontAwesomeIcon icon={faLock} id={styles.icon} />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MapWithLocation;
